export default "__VITE_ASSET__7f1f29de__"